/* istanbul ignore file */
import {
    RECEIVE_BUILD_BOOKING,
    REQUEST_BUILD_BOOKING,
    REQUEST_UPDATE_BOOKING,
    RECEIVE_UPDATE_BOOKING,
} from './types'

export function requestBuildBooking (params) {
    return {
        type: REQUEST_BUILD_BOOKING,
        ...params,
    }
}

export function receiveBuildBooking (
    booking,
    status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_BUILD_BOOKING,
        booking,
        status,
    }
}

export function requestUpdateBooking (params) {
    return {
        type: REQUEST_UPDATE_BOOKING,
        ...params,
    }
}

export function receiveUpdateBooking (
    booking,
    status = {status: 'success', error: null}) {
    return {
        type: RECEIVE_UPDATE_BOOKING,
        booking,
        status,
    }
}
